import { render, staticRenderFns } from "./workflow-popover.vue?vue&type=template&id=641058cc&"
import script from "./workflow-popover.vue?vue&type=script&lang=js&"
export * from "./workflow-popover.vue?vue&type=script&lang=js&"
import style0 from "./workflow-popover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports